import { Node } from '@tiptap/core'
import { TextSelection } from '@tiptap/pm/state'
import { sharedAttrs } from '../shared/shared-attrs'

export const MinuteTitle = Node.create({
  name: 'minute_title',
  content: 'text*',
  defining: true,

  addAttributes() {
    return { ...this.parent?.(), ...sharedAttrs }
  },

  parseHTML() {
    return [{ tag: 'h1[data-type="minute-title"]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['h1', { ...HTMLAttributes, 'data-type': 'minute-title' }, 0]
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        if (!editor.isActive('minute_title')) {
          return false
        }

        const { state, dispatch } = editor.view
        const afterTitle = state.doc.firstChild!.nodeSize
        const resolvedPos = state.doc.resolve(afterTitle)
        dispatch(state.tr.setSelection(TextSelection.near(resolvedPos)))

        return true
      },
      Backspace: ({ editor }) => {
        if (!editor.isActive('minute_title')) {
          return false
        }

        const selection = editor.state.selection
        if (selection instanceof TextSelection && selection.$cursor !== null && selection.$cursor.parentOffset === 0) {
          return true
        }

        return false
      },
    }
  },
})
